import currentSelection from './current-selection'
import panelTrends from './panel-trends'
import workspaceTrends from './workspace-trends'
import treeTrends from './tree-trends'

export default {
    current: 'Current trend selection',
    change: 'Edit trend selection',
    submit: 'Save',

    resetSelection: {
        dialog: {
            title: 'Macro trend selection',
            notice: 'Are you sure you want to delete their entire macro trend selection?',
            confirm: 'Yes, please delete'
        }
    },

    currentSelection,
    panelTrends,
    workspaceTrends,
    treeTrends
}
